import React, {useEffect} from 'react';

import { useViewportHeightVariable } from './hooks/use-viewport-height-variable/use-viewport-height-variable';

function App() {
	//const form = useContactForm();

	useViewportHeightVariable();

	useEffect(() => {
		window.location.href = 'https://pink.gg';
	}, []);

	/*return (
		<ContactFormContext.Provider value={form}>
			<Header/>
			<Home/>
			<Footer/>
		</ContactFormContext.Provider>
	);*/

	return <></>
}

export default App;
